import { apiPost } from "./apiClient";

export const updateAssignment = async (updateAssignmentList) => {
  return apiPost(
    "/updateAssignment",
    { assignmentsInputDto: { blockList: updateAssignmentList } },
    "updating vehicle assignments"
  );
};
